import { Injectable } from '@angular/core';
import { createWorker } from 'tesseract.js';
import { ProcessedImage } from './processed-image.interface';

@Injectable({
  providedIn: 'root',
})
export class TesseractService {
  async processImage(takenImagePng: string): Promise<ProcessedImage> {
    const startTime = Date.now();

    const worker = await createWorker({
      logger: m => console.log(m),
    });

    await worker.load();
    await worker.loadLanguage('eng');
    await worker.initialize('eng');
    await worker.setParameters({
      tessedit_char_whitelist: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890',
    });

    const {
      data: { text },
    } = await worker.recognize(takenImagePng);

    const timeSeconds = Math.round(Date.now() - startTime) / 1000;

    return { time: timeSeconds, result: text, imageUsed: takenImagePng };
  }
}
